import { expireTime, visitRecordKey, visitReferRecordKey } from './const';
export function getFirstVisitURL() {
    const checkVisitRecord = () => {
        const visitRecord = localStorage.getItem(visitRecordKey);
        if (visitRecord) {
            return JSON.parse(visitRecord);
        }
        return null;
    };
    const updateVisitRecord = (route) => {
        const visitRecord = {
            route,
            timestamp: Date.now(),
        };
        localStorage.setItem(visitRecordKey, JSON.stringify(visitRecord));
    };
    const getFirstVisit = () => {
        const visitRecord = checkVisitRecord();
        if (visitRecord) {
            const currentTime = Date.now();
            if (currentTime - visitRecord.timestamp <= expireTime) {
                return visitRecord.route;
            }
        }
        // 需要一个不带 query 的完整url
        const fullUrl = window.location.origin + window.location.pathname;
        updateVisitRecord(fullUrl);
        return fullUrl;
    };
    const data = getFirstVisit();
    return data;
}
export function getFirstVisitRefer() {
    const checkVisitReferRecord = () => {
        const visitRecord = localStorage.getItem(visitReferRecordKey);
        if (visitRecord) {
            return JSON.parse(visitRecord);
        }
        return null;
    };
    const updateVisitRecord = (route) => {
        const visitReferRecord = {
            route,
            timestamp: Date.now(),
        };
        localStorage.setItem(visitReferRecordKey, JSON.stringify(visitReferRecord));
    };
    const getFirstVisitRefer = () => {
        const visitRecord = checkVisitReferRecord();
        if (visitRecord) {
            const currentTime = Date.now();
            if (currentTime - visitRecord.timestamp <= expireTime) {
                return visitRecord.route;
            }
        }
        updateVisitRecord(document.referrer);
        return document.referrer;
    };
    const data = getFirstVisitRefer();
    return data;
}
